import React from "react";

import UpdateImg from "../../../img/upgrade/licenseupgraded.svg"
import UpdateImgMobile from "../../../img/upgrade/licenseupgraded-mobile.svg"
import { WhyUpgrade } from "./WhyUpgrade";

interface NotEligibleLicenseProps {
    email: string;
    didEmailChange: boolean;
    openUpdateContactModal: () => void;
    isUpdateContactErrored: boolean;
}

export function NotEligibleLicense(props: NotEligibleLicenseProps) {
    const { email, openUpdateContactModal, didEmailChange, isUpdateContactErrored } = props;

    return (
        <div className="mainContainer vstack w-100">
            <div className="success-hero vstack w-100 p-0 position-relative">
                <div className="hero-content-wrapper d-flex flex-column flex-lg-row w-100 gap-4 gap-lg-6 align-items-center justify-content-between">
                    <div className="lead-message vstack justify-content-center">
                            <h2 className="header-smaller-light mb-3 mb-md-4">
                                We were unable to automatically convert your existing license
                            </h2>
                        <div>
                            <div className="hstack gap-3 text-start mb-3">
                                <div className="number-step align-self-start">1</div>
                                <div className="vstack gap-2">
                                    <div className="vstack gap-2">
                                    <div className="main-paragraph">
                                        Your dedicated sales representative will contact you shortly using <strong>{email}</strong>
                                    </div>
                            {!didEmailChange && <button
                                onClick={openUpdateContactModal}
                                className="btn btn-primary rounded-pill text-white d-flex align-items-center align-self-start gap-1"
                            >
                                Choose another email
                            </button>}
                            {didEmailChange && <div className="generate-license-alert-success alert-success hstack gap-2 mt-1">
                               <i className="icon-success"></i>
                                <p className="mb-0">Your request has been sent successfully.</p>
                            </div>}
                            {isUpdateContactErrored && <div className="generate-license-alert-danger alert-danger hstack gap-2 mt-1">
                                <i className="icon-warning"></i>
                        <p className="mb-0">There was a problem with sending your request.</p>
                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="hstack gap-3 text-start">
                            <div className="number-step align-self-start">2</div>
                                <div className="vstack gap-2 main-paragraph">
                                    <p className="mb-0">You can check our newest RavenDB version by generating free Developer license</p>
                                    <button
                                        type="button"
                            className="btn btn-primary rounded-pill text-white d-flex align-items-center align-self-start gap-1"
                            onClick={() => window.open("https://ravendb.net/license/request/dev", "_blank")}
                        >
                            Request free Developer license
                        </button>
                                </div>
                        </div>  
                        </div>
                    </div>
                    <div className="success-hero-img">
                        <picture>
                            <source srcSet={UpdateImgMobile} media="(max-width: 990px)" />
                            <img src={UpdateImg} alt="License Upgraded" />
                        </picture>
                    </div>
                </div>
                <div className="text-center text-muted position-absolute bottom-0 start-50 translate-middle-x mb-4 w-100 px-3" style={{ fontSize: '12px'}}>
                    Please note that subscription adjustments, effective January 1st, 2024, apply whether you
                    upgrade now or later. <br className="d-none d-md-block"/> For your subscription, this will be applied on the next payment date.
                    We're here to offer flexible solutions.
                </div>
            </div>
            <WhyUpgrade />
        </div>
    );
}
